(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-pov-selling-plans]').forEach((widget) => {
      if (widget.dataset.initialized === 'true') return;
      widget.dataset.initialized = 'true';

      const options = widget.querySelectorAll('[data-pov-purchase-option]');
      const cards = widget.querySelectorAll('.pov-purchase-option');
      const selects = widget.querySelectorAll('[data-pov-selling-plan-select]');

      const update = (selected) => {
        cards.forEach((card) => card.classList.remove('is-active'));
        selects.forEach((select) => {
          select.disabled = true;
        });

        const card = selected.closest('.pov-purchase-option');
        if (!card) return;
        card.classList.add('is-active');

        const select = card.querySelector('[data-pov-selling-plan-select]');
        if (select) select.disabled = false;
      };

      options.forEach((option) => {
        option.addEventListener('change', () => update(option));
      });

      const checked = widget.querySelector('[data-pov-purchase-option]:checked');
      if (checked) update(checked);
    });
  };

  document.addEventListener('DOMContentLoaded', () => initialize());
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:reorder', () => initialize());

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) initialize(node);
      });
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
